import React, { ReactElement, useMemo } from 'react';
import './SelectProduct.scss';
import SelectProductItem from './SelectProductItem';
import { Variant } from '../../../../Models/Product/Variant';
import { KColumn, KRow } from '../../../KodanshaUIKit/KodanshaGrid/KodanshaGrid';
import { useAtom } from 'jotai';
import { Cart } from '../../../../Models/Cart';
import { CartAtom } from '../../../../store/CartStore';
import { Product } from '../../../../Models/Product';
import { Dayjs } from 'dayjs';
import { FetchMyBooksAtom } from '../../../../store/MyBooksStore';
import { Comic } from '../../../../Models/Comic';
import apiClient from '../../../../API/InkyAPI';
import { isTheChapterInCart, isTheChapterInCartByVolume } from '../../../../utils/utils';
import { useFetchProcessingBooks } from '../../../Hooks/useFetchProcessingBooks';
import Log from '../../../Services/Logger';


export enum SelectProductItemTypes {
    NORMAL,
    MEMBERSHIP
}

enum ServerTypes {
    DIGITAL,
    PRINT
}

// const mockProductItems = [
//     {
//         type: SelectProductItemTypes.NORMAL,
//         serverType: ServerTypes.DIGITAL,
//         title: 'ebook',
//         text: 'Purchase to read this volume and all its chapters online.',
//         price: '7.99',
//     },
//     {
//         type: SelectProductItemTypes.NORMAL,
//         serverType: ServerTypes.PRINT,
//         title: 'print',
//         text: 'Purchase to receive a physical copy of the volume.',
//         price: '10.99',
//     },
//     {
//         type: SelectProductItemTypes.NORMAL,
//         title: 'EBOOK BUNDLE',
//         text: 'Buy all available volumes (34) in this series at a discount.',
//         price: '129.99',
//         discount: '271.66',
//     },
//     {
//         type: SelectProductItemTypes.MEMBERSHIP,
//         title: 'Kodansha+',
//         text: 'The product is available through the Kodansha+ membership.',
//         price: '5.99',
//     },
// ];

const TypeKeys = {
    Digital: {
        type: SelectProductItemTypes.NORMAL,
        serverType: ServerTypes.DIGITAL,
        title: 'Digital Edition',
        text: 'Purchase to read this volume and all its chapters online.',
        price: '7.99',
    },

    Print: {
        type: SelectProductItemTypes.NORMAL,
        serverType: ServerTypes.PRINT,
        title: 'Print Edition',
        text: 'Purchase to receive a physical copy of the volume.',
        price: '10.99',
    },
};

interface SelectProductVariant {
    product: Product;
}

const SelectProduct = ({ product }: SelectProductVariant): ReactElement => {
    const variants = useMemo(() => product.variants?.slice().sort((a, b) => {
        if (a.type === 'Print' && b.type === 'Digital') {
            return -1;
        }
        if (a.type === 'Digital' && b.type === 'Print') {
            return 1;
        }
        return 0;
    }), [product]);
    return (
        <div className='product-select-p-container'>
            {(product.subCategory !== "Book"|| product.getPrintVariant()!== null) && !!product.variants?.length &&
                <>
                    <KRow className='product-select-p-container-title-wrapper'>
                        <KColumn className='product-select-wrapper'>
                            <span className='product-select-p-title'>Select product</span>
                            {/*<span className='product-select-p-sub-text'>SHIPPING & TAXES DETERMINED AT CHECKOUT</span>*/}
                            <span className='product-select-p-sub-text'>TAXES DETERMINED AT CHECKOUT</span>
                        </KColumn>
                        {/* TODO: Post Beta Feature */}
                        {/*{width >= 768 && <KodanshaArrow text={'add to wishlist'} withArrow={false} />}*/}

                    </KRow>
                    <div className='product-select-p-divider' />

                    <div className='product-items-wrapper'>
                        {variants?.map((item) => (
                            <SelectProductItem
                                key={item.id}
                                product={product}
                                variant={item}
                                text={TypeKeys[item.type].text}
                                title={TypeKeys[item.type].title}
                            />
                        ))}
                    </div>
                </>
            }

        </div>
    );
};

export default SelectProduct;